import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './NavBar.css';

function NavBar() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  // Close menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && !event.target.closest('.navbar')) {
        setIsMobileMenuOpen(false);
      }
    };
    
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isMobileMenuOpen]);
  
  return (
    <nav className="navbar">
      {/* Desktop Navigation */}
      <div className="nav-container desktop-nav">
        <Link
          to="/"
          className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
        >
          Home
        </Link>
        <Link
          to="/register"
          className={`nav-link ${location.pathname === '/register' ? 'active' : ''}`}
        >
          Register for Beta
        </Link>
        <Link
          to="/privacy"
          className={`nav-link ${location.pathname === '/privacy' ? 'active' : ''}`}
        >
          Privacy Policy
        </Link>
      </div>
      
      {/* Mobile Navigation */}
      <div className="mobile-nav">
        <button 
          className="hamburger-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
        </button>
        
        <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <Link 
            to="/" 
            className={`mobile-nav-link ${location.pathname === '/' ? 'active' : ''}`}
          >
            Home
          </Link>
          <Link 
            to="/register" 
            className={`mobile-nav-link ${location.pathname === '/register' ? 'active' : ''}`}
          >
            Register for Beta
          </Link>
          <Link
            to="/privacy"
            className={`mobile-nav-link ${location.pathname === '/privacy' ? 'active' : ''}`}
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;